import Vue from 'vue'
import { getAppTenant, TENANT } from '@/environment-detection'

export function mutateAll(state, payload) {
  Object.entries(payload).forEach(([key, value]) => {
    Vue.set(state, key, value)
  })
}

export const createActionErrorHandler = (errorHandlerMutation?: any) => action => async (
  store,
  ...params
) => {
  try {
    const result = await action(store, ...params)
    return result
  } catch (error) {
    if (errorHandlerMutation) {
      store.commit(errorHandlerMutation, error.message)
    } else {
      const errorHandler = Vue.config.errorHandler || console.error
      errorHandler(error)
    }
  }
}

export const actionErrorHandler = createActionErrorHandler()

export const shouldShowBanner = () => {
  const isPosteTenant = getAppTenant() === TENANT.POSTE
  const hasClickedBanner = Boolean(localStorage.getItem('VAS_BANNER_CLICKED'))
  return !isPosteTenant && !hasClickedBanner
}
